import { Component, HostBinding } from '@angular/core';

@Component({
    selector: 'app-module-loading',
    templateUrl: './module-loading.component.html',
    styleUrls: ['./module-loading.component.scss']
})
export class ModuleLoadingComponent {
    @HostBinding('class') classes = 'd-flex-center flex-column vh-100';
}
